<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Consumo final</h1>

      <hr>
      <p class="texto-principal">El consumo final de la energía puede ser no energético y energético.</p>
      <p class="texto-principal">El consumo final no energético corresponde a la energía primaria y secundaria aprovechada como materias primas para la elaboración de bienes no energéticos. Por ejemplo: el gas seco y otros derivados del petróleo se utilizan para elaborar plásticos, solventes, polímeros y caucho; mientras que el bagazo de caña se utiliza para la fabricación de papel, tableros aglomerados y alimento para ganado.</p>
      <p class="texto-principal">Por su lado el consumo final energético se refiere al aprovechamiento de la energía primaria y secundaria para satisfacer necesidades de energía en los distintos sectores, como iluminación, climatización o movilidad.</p>

    </div>
    <div>
      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Consumo final por energético y sector</h3>
          <p class="texto-notas">Datos en peta joules (PJ). Año 2020.</p>
        </div>
        <div class="contenido">
          <div class="graficaConsumoFinal" ref="graficaConsumoFinal">
          </div>
        </div>
        <!--<div class="notas">
            <div class="contenedor"></div>
            <button class="boton-notas">Más información</button>
          </div>-->
      </div>


      <br>

      <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Consumo final 2015-2020</h3>
            <p class="texto-notas">Consumo en peta joules (PJ).</p>
          </div>
          <div class="contenido">
            <div class="barrasProd" ref="barrasProd">
            </div>
            <p class="texto-notas">Elaboración propia a partir de datos del SIM de CENACE y PRODESEN.</p>
          </div>
          <div class="notas">
              
            </div>
        </div>

      <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
        <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
        <ul class="lista-referencias">
          <li><strong><em>Palacios, R., Valles, X., Solís, A., Becerril, A. S., Rodríguez, F., Martínez, H., Rodríguez, J. I., De La Pascua, L. E., Pleitez, R. O., Hernández, F., & Zamudio, J. P. (2022).</em></strong> Estudio del Balance Nacional de Energía 2020. Consejo Nacional de Ciencia y Tecnología (Conacyt), Plataforma Nacional Energía Ambiente y Sociedad (Planeas), Programa Nacional Estratégico de Energía y Cambio Climático (Pronaces-ecc). <a href="https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/" target="_blank">https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/</a></li>
        </ul>            
      </div>

    </div>
  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  
  
  export default {
    name: 'App',
    components: {
      
    },
    data: function () {
      return {
        prodDatos:prodDatos,
        prodVariables:prodVariables,
      }   
    },
    mounted() {

      let chart = am4core.create(this.$refs.graficaConsumoFinal, am4charts.SankeyDiagram);
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = "ConsumoFinalEnergeticoSector";
      chart.exporting.useWebFonts = false;
      chart.language.locale = am4lang_es_ES;
      chart.language.locale["_decimalSeparator"] = ".";
      chart.language.locale["_thousandSeparator"] = ","; 
      chart.dataFields.fromName = "source";
      chart.dataFields.toName = "target";
      chart.dataFields.value = "value";
      chart.dataFields.color = "color";
      chart.paddingLeft = 10;
      chart.paddingRight = 120;

      chart.fontSize = 12;
      
      chart.data = [
            { source: "Carbón", target: "Sector industrial", value: 20.95, color: "#85200c"},
            { source: "Coque de carbón", target: "Sector industrial", value: 44.56, color: "#cc4125"},
            { source: "Coque de petróleo", target: "Sector industrial", value: 126.63, color: "#434343"},
            { source: "Bagazo de caña", target: "Sector industrial", value: 40.6, color: "#f6b26b"},
            { source: "Energía solar", target: "Sector residencial", value: 9.01, color: "#ffff00"},
            { source: "Electricidad", target: "Sector industrial", value: 635.85, color: "#0f0"},
            { source: "Electricidad", target: "Sector transporte", value: 3.41, color: "#0f0"},
            { source: "Electricidad", target: "Sector agropecuario", value: 50.4, color: "#0f0"},
            { source: "Electricidad", target: "Sector comercial y servicios", value: 49.48, color: "#0f0"},
            { source: "Electricidad", target: "Sector público", value: 14.26, color: "#0f0"},
            { source: "Electricidad", target: "Sector residencial", value: 248.32, color: "#0f0"},
            { source: "Leña", target: "Sector residencial", value: 246.62, color: "#b45f06"},
            { source: "Combustóleo", target: "Sector industrial", value: 11.72, color: "#666666"},
            { source: "Combustóleo", target: "Sector transporte", value: 2.09, color: "#666666"},
            { source: "Diésel", target: "Sector industrial", value: 62.2, color: "#b7b7b7"},
            { source: "Diésel", target: "Sector transporte", value: 438.34, color: "#b7b7b7"},
            { source: "Diésel", target: "Sector agropecuario", value: 127.34, color: "#b7b7b7"},
            { source: "Gasolina", target: "Sector industrial", value: 1.47, color: "#cccccc"},
            { source: "Gasolina", target: "Sector transporte", value: 1404.2, color: "#cccccc"},
            { source: "Queroseno", target: "Sector transporte", value: 106.68, color: "#999"},
            { source: "GLP", target: "Sector industrial", value: 46.34, color: "#c9daf8"},
            { source: "GLP", target: "Sector transporte", value: 61.04, color: "#c9daf8"},
            { source: "GLP", target: "Sector agopecuario", value: 4.9, color: "#c9daf8"},
            { source: "GLP", target: "Sector comercial y servicios", value: 61.04, color: "#c9daf8"},
            { source: "GLP", target: "Sector residencial", value: 240.14, color: "#c9daf8"},
            { source: "GLP", target: "Otras ramas económicas", value: 6.62, color: "#c9daf8"},
            { source: "Gas seco", target: "Sector industrial", value: 438.81, color: "#6d9eeb"},
            { source: "Gas seco", target: "Sector transporte", value: 1.81, color: "#6d9eeb"},
            { source: "Gas seco", target: "Sector comercial y servicios", value: 9.5, color: "#6d9eeb"},
            { source: "Gas seco", target: "Sector residencial", value: 25.95, color: "#6d9eeb"},
            { source: "Gas seco", target: "PEMEX Petroquímica", value: 12.05, color: "#6d9eeb"},
            { source: "No energéticos", target: "Otras ramas económicas", value: 30.4, color: "#ff00ff"},

      ];

      this.chart = chart;

      //Gráfica: Comercio exterior de energéticos - Importación
      let chart3 = am4core.create(this.$refs.barrasProd, am4charts.XYChart);
      chart3.exporting.menu = new am4core.ExportMenu();
      chart3.exporting.filePrefix = "ConsumoFinalAnio";
      chart3.exporting.useWebFonts = false;
      chart3.language.locale = am4lang_es_ES;
      chart3.language.locale["_decimalSeparator"] = ".";
      chart.language.locale["_thousandSeparator"] = ","; 
      //chart3.paddingLeft = 50;
      //chart3.paddingRight = 50;
      chart3.fontSize = 12;

      chart3.data = prodDatos;

      // Create axes
      let categoryAxis3 = chart3.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis3.dataFields.category = "a";
      categoryAxis3.renderer.grid.template.location = 0;
      categoryAxis3.renderer.labels.template.fontSize = 14;
      categoryAxis3.title.text = "Año";
      categoryAxis3.renderer.minGridDistance = 20;
      categoryAxis3.fontSize = 11;

      let valueAxis3 = chart3.yAxes.push(new am4charts.ValueAxis());
      valueAxis3.renderer.inside = false;
      valueAxis3.min = 0;
      //valueAxis3.max = 1000;
      valueAxis3.title.text = "Consumo (PJ)";
      valueAxis3.strictMinMax = true;
      valueAxis3.calculateTotals = true;
      valueAxis3.renderer.minWidth = 50;
      valueAxis3.fontSize = 11;

      // Create series
      function createSeries3(field, name, color) {
        
        // Set up series
        let series = chart3.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 1;
        series.strokeWidth = 0;
        
        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
        
        // Add label
        let bullet = series.bullets.push(new am4charts.LabelBullet());
        bullet.interactionsEnabled = false;
        bullet.label.hideOversized = true;
        bullet.label.text = "{valueY.totalPercent.formatNumber('#.0')}%";
        bullet.locationY = 0.5;
        bullet.label.fill = am4core.color("#ffffff");
        bullet.label.fontSize = 11;

        return series;
      }

      for(var i=0; i<prodVariables.length; i++)
      {
        let v = prodVariables[i];
        createSeries3(v.id, v.nombre,v.color);
      }

      // Legend
      chart3.legend = new am4charts.Legend();
      chart3.legend.useDefaultMarker = true;
      chart3.legend.scrollable = true;
      chart3.legend.maxHeight = 150;

      let marker3 = chart3.legend.markers.template.children.getIndex(0);
      marker3.cornerRadius(12, 12, 12, 12);
      marker3.strokeWidth = 2;
      marker3.strokeOpacity = 1;
      marker3.stroke = am4core.color("#fff");

      this.chart3 = chart3;
        

    },
    methods: {
      tooltipProduccion(d) {
        return `Consumo<br>${d.a}: ${
          this.prodVariables.find(v => v.id === d.key).nombre
        } | <b>${d[d.key].toFixed(2)}</b> (${((d[d.key] / Object.values(d)
          .filter(f => parseFloat(f)).reduce((a,b) => a+b)
        ) * 100).toFixed(2)}%)`
      },
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }

      if (this.chart3) {
        this.chart3.dispose();
      }
    },
  }


  
const prodDatos = [
  {
    "a": '2015',
    "Carbon": 84.58,
    "RadiacionSolar": 9.43,
    "Bagazo": 37.42,
    "Leña": 252.91,
    "CoqueCarbon": 58.64,
    "CoquePetroleo": 128.79,
    "GLP": 419.92,
    "Gasolina": "1,522.11",
    "Queroseno": 142.85,
    "Diesel": 868.89,
    "Combustoleo": 23.08,
    "NoEnergeticos": 126.5,
    "GasSeco": 684.84,
    "Electricidad": 860.43
  },
  {
    "a": '2016',
    "Carbon": 63.76,
    "RadiacionSolar": 10.57,
    "Bagazo": 38.52,
    "Leña": 251.65,
    "CoqueCarbon": 63.52,
    "CoquePetroleo": 138.22,
    "GLP": 421.12,
    "Gasolina": "1,564.91",
    "Queroseno": 154.32,
    "Diesel": 856.34,
    "Combustoleo": 33.56,
    "NoEnergeticos": 129.53,
    "GasSeco": 725.72,
    "Electricidad": 815.28
  },
  {
    "a": '2017',
    "Carbon": 237.44,
    "RadiacionSolar": 10.89,
    "Bagazo": 50.13,
    "Leña": 250.39,
    "CoqueCarbon": 63.75,
    "CoquePetroleo": 142.33,
    "GLP": 422.47,
    "Gasolina": "1,521.49",
    "Queroseno": 175.14,
    "Diesel": 807.73,
    "Combustoleo": 29.94,
    "NoEnergeticos": 102.82,
    "GasSeco": 754.47,
    "Electricidad": 942.28
  },
  {
    "a": '2018',
    "Carbon": 186.93,
    "RadiacionSolar": 12.53,
    "Bagazo": 55.98,
    "Leña": 249.14,
    "CoqueCarbon": 47.43,
    "CoquePetroleo": 143.24,
    "GLP": 426.54,
    "Gasolina": "1,546.74",
    "Queroseno": 185.7,
    "Diesel": 782.59,
    "Combustoleo": 11.61,
    "NoEnergeticos": 87.45,
    "GasSeco": 596.76,
    "Electricidad": 990.24
  },
  {
    "a": '2019',
    "Carbon": 121.69,
    "RadiacionSolar": 13.81,
    "Bagazo": 36.44,
    "Leña": 247.88,
    "CoqueCarbon": 57.03,
    "CoquePetroleo": 152.9,
    "GLP": 427.38,
    "Gasolina": "1,574.19",
    "Queroseno": 187.07,
    "Diesel": 629.77,
    "Combustoleo": 15.96,
    "NoEnergeticos": 65.39,
    "GasSeco": 563.26,
    "Electricidad": "1,023.88"
  },
  {
    "a": '2020',
    "Carbon": 20.95,
    "RadiacionSolar": 16.27,
    "Bagazo": 40.74,
    "Leña": 246.62,
    "CoqueCarbon": 44.56,
    "CoquePetroleo": 126.63,
    "GLP": 420.08,
    "Gasolina": "1,405.69",
    "Queroseno": 106.68,
    "Diesel": 627.88,
    "Combustoleo": 13.81,
    "NoEnergeticos": 30.43,
    "GasSeco": 488.12,
    "Electricidad": "1,001.75"
  }
], 
prodVariables = [
  {"id":"Carbon","nombre":"Carbón","color":"#85200c"},
  {"id":"RadiacionSolar","nombre":"Radiación solar","color":"#ffff00"},
  {"id":"Bagazo","nombre":"Bagazo de caña","color":"#f6b26b"},
  {"id":"Leña","nombre":"Leña","color":"#b45f06"},
  {"id":"CoqueCarbon","nombre":"Coque de carbón","color":"#cc4125"},
  {"id":"CoquePetroleo","nombre":"Coque de petróleo","color":"#434343"},
  {"id":"GLP","nombre":"GLP","color":"#c9daf8"},
  {"id":"Gasolina","nombre":"Gasolina","color":"#cccccc"},
  {"id":"Queroseno","nombre":"Queroseno","color":"#999999"},
  {"id":"Diesel","nombre":"Diésel","color":"#b7b7b7"},
  {"id":"Combustoleo","nombre":"Combustóleo","color":"#666666"},
  {"id":"NoEnergeticos","nombre":"No energéticos","color":"#ff00ff"},
  {"id":"GasSeco","nombre":"Gas seco","color":"#6d9eeb"},
  {"id":"Electricidad","nombre":"Electricidad","color":"#00ff00"},
];

</script>
<style scoped lang="scss">

.graficaConsumoFinal {
    width: 100%;
    height: 600px;
  }

  .barrasProd {
    width: 100%;
    height: 600px;
  }

</style>
